const dateFormat = require('dateformat');

const monthDayYear = d => {
  const date = new Date(d);

  return dateFormat(date, 'mmmm dS, yyyy');
};

const formattedDate = (date, timezoneId) => {
  if (timezoneId) {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      timeZone: timezoneId,
      timeZoneName: 'short'
    });
  }
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
};

const dateString = (date = new Date(), timezone = null) => {
  return timezone
    ? new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        timeZone: timezone,
        timeZoneName: 'short'
      })
    : new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
      });
};

const daysAgoInSeconds = days => {
  const d = new Date();
  d.setDate(d.getDate() - days);
  return d / 1000; // ms -> s
};

export { formattedDate, monthDayYear, daysAgoInSeconds, dateString };
